import React from 'react'
import PropTypes from 'prop-types'

const PathwayProgressIcon = ({ className }) => (
  <svg
    className={className}
    height="24px"
    version="1.1"
    viewBox="0 0 24 24"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      id="ss_icon_pathwayprogress"
      stroke="none"
      strokeWidth="1"
    >
      <rect
        fill="#FDE6F0"
        height="24"
        id="Rectangle"
        rx="12"
        width="24"
        x="0"
        y="0"
      />
      <circle
        cx="12"
        cy="10.7770997"
        id="Oval"
        r="3.59806592"
        stroke="#C62D70"
        strokeWidth="2"
      />
      <polyline
        fill="#C62D70"
        id="Path-3"
        points="10.8718499 14.4314514 12 19.4314514 13.032542 14.4314514"
        stroke="#C62D70"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

PathwayProgressIcon.propTypes = {
  className: PropTypes.string,
}

export default PathwayProgressIcon
